module.exports = __webpack_public_path__ + "img/cartoriosparticipante.6658620d.png";